<template>
  <label class="radio-button">
    <input v-bind="$attrs" type="radio" class="radio" :checked="isChecked" @change="handleChange" />
    <!-- @slot ラベル -->
    <span v-if="$slots.default" class="label"><slot /></span>
  </label>
</template>

<script>
/**
 * ラジオボタン
 */
export default {
  name: 'RadioButton',
  inheritAttrs: false,
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    /** 値 */
    value: [String, Number, Object],
    /** チェック状態 (v-model) */
    checked: [Boolean, Number, String],
  },
  computed: {
    isChecked() {
      return `${this.checked}` === `${this.value}` || this.checked === true
    },
  },
  methods: {
    handleChange() {
      /**
       * 選択値 (v-model)
       * @event change
       * @type {String|Number|Object}
       */
      this.$emit('change', this.value)
    },
  },
}
</script>

<style lang="postcss" scoped>
.radio-button {
  align-items: center;
  display: inline-grid;
  grid-auto-flow: column;
  grid-gap: 8px;
  justify-content: flex-start;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  width: fit-content;
}

.radio {
  appearance: none;
  background: var(--white);
  border: 2px solid var(--border-color);
  border-radius: 50%;
  box-sizing: border-box;
  cursor: pointer;
  height: 32px;
  margin: 4px;
  outline: none;
  position: relative;
  width: 32px;

  &:checked {
    border-color: var(--moderate-blue);

    &::after {
      background: var(--moderate-blue);
      border-radius: 50%;
      content: '';
      height: 16px;
      margin: 6px;
      position: absolute;
      width: 16px;
    }
  }

  &:disabled {
    border-color: var(--border-color);
    cursor: default;

    &::after {
      background: var(--light-gray);
    }
  }

  .responsive & {
    @media screen and (--sp-size) {
      height: 20px;
      width: 20px;

      &:checked::after {
        height: 9px;
        left: 50%;
        margin: 0;
        top: 50%;
        -webkit-transform: translateY(-50%) translateX(-50%);
        transform: translateY(-50%) translateX(-50%);
        width: 9px;
      }
    }
  }
}

.label {
  font-weight: 600;
}
</style>
